import axios from "axios";
import config from "../../../config";
import {
	APPOINTMENT_PROVIDER_ALL,
	APPOINTMENT_TODAY,
	APPOINTMENT_UPCOMING,
	APPOINTMENT_REQUEST,
	APPOINTMENT_PAYMENT,
	APPOINTMENT_ACCEPT,
	APPOINTMENT_CANCEL,
	APPOINTMENT_PAID,
	SHOW_SPINNING,
	SET_ERROR_MESSAGE,
	APPOINTMENT_JOIN,
	APPOINTMENT_JOIN_MSG,

	APPOINTMENT_LIST_ALL,
	APPOINTMENT_GET,
	APPOINTMENT_CREATE,
	APPOINTMENT_DELETE,
	APPOINTMENT_EDIT,
	CLIENT_MUSIC_BACKGROUND, APPOINTMENT_EVENT,
} from "../types/types";

const instance = axios.create({
	baseURL: config.SIM_API_URL,
	timeout: 30000,
});

// Add a response interceptor
instance.interceptors.response.use(function (response) {
	return response;
}, function (error) {

	if(error.response.status === 403) {
		localStorage.setItem("role", '');
		localStorage.setItem("client", '');
		localStorage.setItem("client_id", '');
		localStorage.setItem("client_name", '');
		localStorage.setItem("client_email", '');
		window.location.href = "/login";
	}
	return Promise.reject(error);
});

export const reset = () => dispatch => {
	dispatch({
		type: APPOINTMENT_CREATE,
		payload: '',
	});
	dispatch({
		type: APPOINTMENT_EDIT,
		payload: '',
	});
	dispatch({
		type: APPOINTMENT_DELETE,
		payload: '',
	});
	dispatch({
		type: APPOINTMENT_ACCEPT,
		payload: '',
	});
	dispatch({
		type: APPOINTMENT_JOIN,
		payload: '',
	});
	dispatch({
		type: APPOINTMENT_JOIN_MSG,
		payload: '',
	});
};

export const createAppointment = (data) => dispatch => {
	dispatch({type: SHOW_SPINNING, payload: true});
	instance
		.post("api/appointments/create-request-appointment", data)
		.then(res => {
			dispatch({type: SHOW_SPINNING, payload: false});
			dispatch({
				type: APPOINTMENT_CREATE,
				payload: res.data.msg,
			});
		})
		.catch(err => {
			dispatch({type: SHOW_SPINNING, payload: false});
			dispatch({
				type: APPOINTMENT_CREATE,
				payload: err && err.response && err.response.data && err.response.data.msg,
			});
		});
};

export const editAppointment = (data) => dispatch => {
	instance
		.post("api/appointments/edit-appointment", data)
		.then(res => {
			console.log(res.data.results);
			dispatch({
				type: APPOINTMENT_EDIT,
				payload: res.data.msg,
			});

			window.location.href = "/appointment";
		})
		.catch(err => {
			dispatch({
				type: APPOINTMENT_EDIT,
				payload: err && err.response && err.response.data && err.response.data.msg,
			});
		})
};

export const deleteAppointment = (data) => dispatch => {
	instance
		.post("api/appointments/cancel-appointment", data)
		.then(res => {
			dispatch({
				type: APPOINTMENT_DELETE,
				payload: res.data.msg,
			});
			window.location.href = "/appointment";
		})
		.catch(err => {
			dispatch({
				type: APPOINTMENT_DELETE,
				payload: err && err.response && err.response.data && err.response.data.msg,
			});
		})
};

export const appointmentProviders = () => dispatch => {
	instance
		.get("api/appointments/get-providers-appointment",)
		.then(res => {
			dispatch({
				type: APPOINTMENT_PROVIDER_ALL,
				payload: res.data.results,
			});
		})
		.catch(err => {
			console.log(err.toString());
		})
};

export const appointmentAccept = (data) => dispatch => {
	instance
		.post("api/appointments/accept-appointment", data)
		.then(res => {
			dispatch({
				type: APPOINTMENT_ACCEPT,
				payload: res.data.msg,
			});
		})
		.catch(err => {
			console.log(err.toString());
		})
};

export const appointmentCancel = (data) => dispatch => {
	instance
		.post("api/appointments/cancel-appointment", data)
		.then(res => {
			dispatch({
				type: APPOINTMENT_CANCEL,
				payload: res.data.msg,
			});
		})
		.catch(err => {
			console.log(err.toString());
		})
};

export const appointmentToday = (data) => dispatch => {
	instance
		.post("api/appointments/get-today-appointment", data)
		.then(res => {
			dispatch({
				type: APPOINTMENT_TODAY,
				payload: res.data.results,
			});
		})
		.catch(err => {
			console.log(err.toString());
		})
};

export const appointmentUpcoming = (data) => dispatch => {
	instance
		.post("api/appointments/get-upcoming-appointment", data)
		.then(res => {
			dispatch({
				type: APPOINTMENT_UPCOMING,
				payload: res.data.results,
			});
		})
		.catch(err => {
			console.log(err.toString());
		})
};

export const appointmentPaymentRequest = (data) => dispatch => {
	instance
		.post("api/appointments/get-payment-appointment", data)
		.then(res => {
			dispatch({
				type: APPOINTMENT_PAYMENT,
				payload: res.data.results,
			});
		})
		.catch(err => {
			console.log(err.toString());
		})
};

export const appointmentPaidRequest = (data) => dispatch => {
	instance
		.post("api/appointments/get-paid-appointment", data)
		.then(res => {
			dispatch({
				type: APPOINTMENT_PAID,
				payload: res.data.results,
			});
		})
		.catch(err => {
			console.log(err.toString());
		})
};

export const appointmentAppointmentRequest = (data) => dispatch => {
	instance
		.post("api/appointments/get-request-appointment", data)
		.then(res => {
			dispatch({
				type: APPOINTMENT_REQUEST,
				payload: res.data.results,
			});
		})
		.catch(err => {
			console.log(err.toString());
		});
};

let error_timer = null;
export const payAppointment = (data) => dispatch => {
	dispatch({type: SHOW_SPINNING, payload: true});
	instance
		.post("api/appointments/pay", data)
		.then(res => {
			dispatch({type: SHOW_SPINNING, payload: false});
		})
		.catch(err => {
			dispatch({
				type: SET_ERROR_MESSAGE,
				payload: err && err.response && err.response.data && err.response.data.msg,
			});
			window.location.href = "/dashboard";
			if(error_timer !== null){
				clearTimeout(error_timer);
				error_timer = null;
			}
			error_timer = setTimeout(() => {
				dispatch({type: SET_ERROR_MESSAGE, payload: ''});
				error_timer = null;
			}, 10000);
			dispatch({type: SHOW_SPINNING, payload: false});
		});
};

export const getAppointmentList = (data) => dispatch => {
	instance
		.post("api/appointments/get-clients-appointment", data)
		.then(res => {
			dispatch({
				type: APPOINTMENT_LIST_ALL,
				payload: res.data.results,
			});

		})
		.catch(err => {
			console.log(err.toString());
		})
};

export const appointmentById = (data) => dispatch => {
	instance
		.post("api/appointments/get-appointment", data)
		.then(res => {
			dispatch({
				type: APPOINTMENT_GET,
				payload: res.data.results,
			});
		})
		.catch(err => {
			console.log(err.toString());
		})
};

export const joinAppointment = (data) => dispatch => {
	instance
		.post("api/appointments/join-appointment", data)
		.then(res => {
			dispatch({
				type: APPOINTMENT_JOIN,
				payload: res.data.msg,
			});
		})
		.catch(err => {
			console.log("Failed.", err.toString());
			dispatch({
				type: APPOINTMENT_JOIN_MSG,
				payload: err && err.response && err.response.data && err.response.data.msg,
			});
		})
};
export const outAppointment = (data) => dispatch => {
	instance
		.post("api/appointments/out-appointment", data)
		.then(res => {
			console.log("out appointment = ", res.data.msg);
			dispatch({
				type: APPOINTMENT_JOIN,
				payload: res.data.msg,
			});
			// dispatch({
			// 	type: APPOINTMENT_EVENT,
			// 	payload: "session-close",
			// });
		})
		.catch(err => {
			console.log(err.toString());
			dispatch({
				type: APPOINTMENT_JOIN,
				payload: err && err.response && err.response.data && err.response.data.msg,
			});
			// dispatch({
			// 	type: APPOINTMENT_EVENT,
			// 	payload: "session-close",
			// });
		})
};
export const testAppointment = (data) => dispatch => {
	instance
		.post("api/appointments/test-appointment", data)
		.then(res => {
			dispatch({
				type: APPOINTMENT_JOIN,
				payload: res.data.msg,
			});
		})
		.catch(err => {
			console.log(err.toString());
		})
};
/**
 * Appointment background image and music settings
 */
export const setRoomAppointment = (data) => dispatch => {
	instance
		.post("api/appointments/set-room-appointment", data)
		.then(res => {
			if (res.status === 200) {
				console.log(res.data.msg);
			}
		})
		.catch(err => {
			if (err.status === 400) {
				console.log(err && err.response && err.response.data && err.response.data.msg);
			}
		})
};

export const getMusicImageByAppointmentId = (data) => dispatch => {
	instance
		.post("api/appointments/get-background-appointment", data)
		.then(res => {
			dispatch({
				type: CLIENT_MUSIC_BACKGROUND,
				payload: res.data.results,
			});
			console.log(res.data.msg);
		})
		.catch(err => {
			if (err.status === 400) {
				console.log(err && err.response && err.response.data && err.response.data.msg);
			}
		})
};

/**
 * Event Source
 */
export const onEvent = (data) => dispatch => {
	dispatch({
		type: APPOINTMENT_EVENT,
		payload: data,
	});
};